
















import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

const HeaderFlyoutContentProps = Vue.extend({
  props: {
    flyoutContent: String,
  },
});

@Component
export default class HeaderFlyoutContent extends HeaderFlyoutContentProps {
  modifiedContent: string|null = null;
  imageCount = 0;
  listCount = 0;

  @Watch('flyoutContent')
  adaptHeaderFlyout (): void {
    const div = document.createElement('div');
    div.innerHTML = this.flyoutContent || this.$el.innerHTML;
    this.imageCount = div.querySelectorAll('brandhub-header-flyout-image-item').length;
    this.listCount = div.querySelectorAll('brandhub-header-flyout-list-item').length;
    const noListLargeImages = this.listCount <= 0 && this.imageCount <= 5;
    const oneListLargeImages = this.listCount === 1 && this.imageCount <= 3;
    const twoListLargeImages = this.listCount === 2 && this.imageCount === 1;

    // Elements where the first item is large
    if (noListLargeImages || oneListLargeImages || twoListLargeImages) {
      const elem = div.querySelector('brandhub-header-flyout-image-item');
      if (elem) {
        elem.setAttribute('large-item', 'true');
      }
    }

    // Elements where the second item is large
    if (this.imageCount === 2 && this.listCount <= 0) {
      const elem = div.querySelector('.headerflyoutimageitem:nth-child(2) brandhub-header-flyout-image-item');
      if (elem) {
        elem.setAttribute('large-item', 'true');
      }
    }

    this.modifiedContent = div.innerHTML;
  }

  offClick (event: Event) {
    if ((event.target as HTMLElement).tagName === 'BRANDHUB-FLYOUT-BUTTON') {
      event.preventDefault();
    }
    if ((event.target as HTMLElement).classList.contains('brandhub-header-flyout__bold-button-row')) {
      this.$emit('close-flyout');
    }
  }

  get rootClasses () {
    return {
      'brandhub-header-flyout__content-wrapper--0-images': this.imageCount === 0,
      'brandhub-header-flyout__content-wrapper--1-image': this.imageCount === 1,
      'brandhub-header-flyout__content-wrapper--2-images': this.imageCount === 2,
      'brandhub-header-flyout__content-wrapper--3-images': this.imageCount === 3,
      'brandhub-header-flyout__content-wrapper--4-images': this.imageCount === 4,
      'brandhub-header-flyout__content-wrapper--5-images': this.imageCount === 5,
      'brandhub-header-flyout__content-wrapper--6-images': this.imageCount === 6,
      'brandhub-header-flyout__content-wrapper--7-images': this.imageCount === 7,
      'brandhub-header-flyout__content-wrapper--8-images': this.imageCount === 8,
      'brandhub-header-flyout__content-wrapper--0-lists': this.listCount === 0,
      'brandhub-header-flyout__content-wrapper--1-list': this.listCount === 1,
      'brandhub-header-flyout__content-wrapper--2-lists': this.listCount === 2,
      'brandhub-header-flyout__content-wrapper--3-lists': this.listCount === 3,
      'brandhub-header-flyout__content-wrapper--4-lists': this.listCount === 4,
    };
  }

  created (): void {
    this.adaptHeaderFlyout();
  }
}
